import { supabase } from "./supabase";

/**
 * Reads `user_profiles.welcome_seen_at` for the signed-in user. Returns null
 * when the column is unset (first login) or when no session is present.
 *
 * The /client dashboard uses this on mount to decide whether to bounce
 * first-time visitors to /client/welcome. Failures fail-open (treat as
 * "seen") so a transient query error never traps the user on the welcome
 * screen.
 */
export async function getWelcomeSeenAt(): Promise<string | null> {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData.user) return new Date().toISOString();
  const { data, error } = await supabase
    .from("user_profiles")
    .select("welcome_seen_at")
    .eq("id", userData.user.id)
    .maybeSingle();
  if (error || !data) return new Date().toISOString();
  return (data as { welcome_seen_at: string | null }).welcome_seen_at;
}

/** Idempotent: marks `welcome_seen_at = now()` on the signed-in user's profile. */
export async function markWelcomeSeen(): Promise<void> {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData.user) return;
  await supabase
    .from("user_profiles")
    .update({ welcome_seen_at: new Date().toISOString() })
    .eq("id", userData.user.id);
}
